import { render, staticRenderFns } from "./EiCarousel.vue?vue&type=template&id=685c45a5&scoped=true&"
import script from "./EiCarousel.vue?vue&type=script&lang=js&"
export * from "./EiCarousel.vue?vue&type=script&lang=js&"
import style0 from "./EiCarousel.vue?vue&type=style&index=0&id=685c45a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685c45a5",
  null
  
)

export default component.exports